import React from 'react';

import { PortableText } from '../portableText';

interface LongformContentProps {
	_rawText: any;
	className: string;
	dynamicContent: any;
	text: any;
	useDynamicContent: boolean;
}

export function LongformContent({
	_rawText,
	className,
	dynamicContent,
	text,
	useDynamicContent,
}: LongformContentProps) {
	const contentBlocks =
		useDynamicContent && dynamicContent ? dynamicContent : _rawText || text;

	return <PortableText blocks={contentBlocks} className={className} />;
}
